import { ApplicationError } from 'models/Error';
import { invitation } from 'repositories/invitation';
import { Result, Success } from 'types';
import { convertToInvitation } from 'models/Invitation/transfer';
import { Invitation } from 'models/Invitation/type';

export class InvitationDomain {
  static async detail(
    token: string
  ): Promise<Result<Invitation, ApplicationError>> {
    try {
      const response = await invitation.detail(token);
      return new Success(convertToInvitation(response));
    } catch (e) {
      return ApplicationError.handleForRepositoryError(e);
    }
  }
}
